import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AngularPaths } from '@models/index.model';
import { MessageType } from '@models/response.model';
import { FeedMessageService, UtilsService } from '@services/index.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ErrorPathGuard  {
  constructor(private _router: Router, private _utils: UtilsService, private _notify: FeedMessageService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const errorMsg: string = route.paramMap.get('msg');
    if (!!errorMsg) {
      this._notify.feedBackResult(MessageType.ERROR, this._utils.decodedData(errorMsg));
    }
    return this._router.parseUrl(AngularPaths.DEFAULT);
  }
}
